import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-point-heads',
  templateUrl: './check-point-heads.component.html',
  styleUrls: ['./check-point-heads.component.css']
})
export class CheckPointHeadsComponent implements OnInit {
    argType;

    argValue;

    public itemsListCheckPoints: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadCheckPoints() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListCheckPoints = await this.datatask.Post(1667, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadCheckPoints();
    }

    ngOnInit() {
        this.init();
    }
}
